<template lang="html">
  <div class="preferences-special">
    <template v-if="errorDescription">
      <div class="error">
        {{ errorDescription && errorDescription.message ? errorDescription.message : $tr('common.errrorLoadingPageContent') }}
      </div>
    </template>
    <template v-else>
      <div class="column-checkbox">
        <input v-model="isLanding" type="checkbox" class="checkbox" id="put-on-landing">
        <label for="put-on-landing"></label>
        <span>{{ $tr('vacancy.preferences.special.publishedOnLanding') }}</span>
      </div>

      <div class="row-block">
        <div>
          <label>{{ $tr('vacancy.preferences.special.category') }}</label>
          <multiselect
            v-model="category"
            :options="categories"
            :show-labels="false"
            :allow-empty="false"
            :searchable="false"
            track-by="id"
            label="name"
            :placeholder="$tr('vacancy.preferences.special.category')"
          />
        </div>
        <div class="help">
          <span>{{ $tr('vacancy.preferences.special.categoryHelper') }}</span>
        </div>
      </div>

      <div class="row-block">
        <div>
          <label>{{ $tr('vacancy.preferences.special.descriptionRu') }}</label>
          <vcv-editor
            ref="quillRu"
            id="descriptionRu"
            v-model="descriptionRu"
            :editorToolbar="editorToolbar"
            :toolbarButtons="{bold: true, italic: true, list: true, link: true}"
            :style="{ borderColor: errors.has('description') ? 'red' : '' }"
            name="descriptionRu"
          />
        </div>
        <div class="help">
          <span>{{ $tr('vacancy.preferences.special.descriptionHelper') }}</span>
        </div>
      </div>

      <div class="row-block">
        <div>
          <label>{{ $tr('vacancy.preferences.special.descriptionEn') }}</label>
          <vcv-editor
            ref="quillEn"
            id="descriptionEn"
            v-model="descriptionEn"
            :editorToolbar="editorToolbar"
            :toolbarButtons="{bold: true, italic: true, list: true, link: true}"
            :style="{ borderColor: errors.has('description') ? 'red' : '' }"
            name="descriptionEn"
          />
        </div>
        <div class="help">
          <span>{{ $tr('vacancy.preferences.special.descriptionHelper') }}</span>
        </div>
      </div>
      <div class="button-wrapper">
        <vbutton label="common.save" @click="save"/>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'process-vacancy-preferences-special',

  computed: {
    vacancy () {
      return this.$store.getters['vacancy/one']
    },

    storeDescription () {
      return this.$store.state.process.batPersonalAccount.vacancy.description
    },

    loadingDescription () {
      return this.storeDescription.loading
    },

    errorDescription () {
      return this.storeDescription.error
    },

    storeCategories () {
      return this.$store.state.process.batPersonalAccount.vacancy.categories
    },

    loadingCategories () {
      return this.storeCategories.loading
    },

    errorCategories () {
      return this.storeCategories.error
    },

    categories () {
      return this.$store.getters['process/batPersonalAccount/vacancy/categories/getCategories']
    },

    descriptionRu: {
      get () {
        return this.storeDescription.data ? this.storeDescription.data.description_ru : ''
      },
      set (value) {
        this.change('description_ru', value)
      }
    },

    descriptionEn: {
      get () {
        return this.storeDescription.data ? this.storeDescription.data.description_en : ''
      },
      set (value) {
        this.change('description_en', value)
      }
    },

    isLanding: {
      get () {
        return Boolean(this.storeDescription.data ? this.storeDescription.data.is_landing : false)
      },
      set (value) {
        this.change('is_landing', value)
      }
    },

    category: {
      get () {
        return this.storeDescription.data ? this.storeDescription.data.category : null
      },
      set (value) {
        this.change('category', value)
      }
    },

    editorToolbar () {
      return [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'header': 1}, {'header': 2}]
        // ['source']
      ]
    }
  },

  methods: {
    fetch () {
      this.$store.dispatch('process/batPersonalAccount/vacancy/categories/fetch')
      this.$store.dispatch('process/batPersonalAccount/vacancy/description/fetch', this.vacancy)
    },

    change (field, value) {
      this.$store.dispatch('process/batPersonalAccount/vacancy/description/update', {field, value})
    },
    save() {
      this.$store.dispatch('process/batPersonalAccount/vacancy/description/save', this.vacancy)
    }
  },

  beforeMount () {
    this.fetch()

    // add event listener for common save button click // add event listener for common save button click
    // double $parent, because of use of proxy component: Component where event occur -> Special (proxy) -> SpecialProcess (our)
    // this.$parent.$parent.$on('saveOnParent', () => {
    //  this.$store.dispatch('process/batPersonalAccount/vacancy/description/save', this.vacancy)
    // })
  },

  mounted () {
    const processSHowSourceCode = (ref) => {
      const id = setInterval(() => {
        if (ref) {
          return
        }

        clearInterval(id)

        const txtArea = document.createElement('textarea')
        txtArea.style.cssText = 'display:none;'
        txtArea.classList.add('ql-code')

        const htmlEditor = ref.quill.addContainer('ql-custom')
        htmlEditor.appendChild(txtArea)

        ref.quill.on('text-change', (delta, oldDelta, source) => {
          txtArea.value = ref.editor.innerHTML
        })
        txtArea.value = ref.editor.innerHTML
      }, 1000)
    }

    processSHowSourceCode(this.$refs.quillRu)
    processSHowSourceCode(this.$refs.quillEn)
  },

  destroyed () {
    // this.$parent.$parent.$off('saveOnParent')
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../styles/colors.scss";

  .preferences-special {
    margin-top: 30px;
    margin-bottom: 30px;

    .row-block {
      display: flex;
      margin: 40px 0 40px 0;
      align-items: flex-start;
      justify-content: space-between;
      max-width: 1000px;

      & > div:first-child {
        width: calc(60% - 40px);
        margin-right: 40px;
      }

      div.help {
        padding-top: 28px;
        width: 40%;

        span {
          display: block;
          padding: 10px 15px;
          border-radius: 5px;
          background-color: $line-statuses-status-settings-bg;
        }
      }

      label {
        font-size: 16px;
        display: block;
        margin-bottom: 10px;
      }

      input[name=name] {
        padding: 8px 5px;
      }

      input,
      textarea {
        width: 100%;
        font-size: 16px;

        &.registrationLink,
        &.videoLink {
          cursor: text;
          font-size: 16px;
        }
      }

      p {
        margin-left: 23px;
        width: 33.3333%;
      }
    }

    .column-checkbox {
      font-size: 16px;
      + .column-checkbox {
        margin-top: 22px;
      }
    }
  }
</style>
